module.exports = __webpack_public_path__ + "static/img/8.a9b6cae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/8.png
// module id = PV+f
// module chunks = 0